import { AlertTriangle, Ban, CheckCircle2, Repeat2 } from "lucide-react";
import { assetUrl } from "@/lib/api";
import CostSummary from "./CostSummary";
import Replacements from "./Replacements";

const ACTION = { keep: "Resta", stock: "Nuova foto stock", ai: "Generata con AI", keep_client: "Copiata (autorizzata)", logo: "Logo testuale" };

function List({ icon: Icon, title, items, tone, testid }) {
  return (
    <div data-testid={testid}>
      <p className={`text-xs font-semibold uppercase tracking-wider ${tone}`}>{title}</p>
      <ul className="mt-2 space-y-1.5">{items.map((x) => <li key={x} className="flex gap-2 text-sm text-slate-700"><Icon size={15} className={`mt-0.5 shrink-0 ${tone}`} />{x}</li>)}</ul>
    </div>
  );
}

export default function PreviewStep({ preview: p, rows, setRows, custom, setCustom, confirmed, setConfirmed }) {
  const ai = p.mode !== "simple";
  return (
    <div className="space-y-6" data-testid="dup-preview-step">
      <div className="grid gap-5 md:grid-cols-3">
        <List icon={Repeat2} title="Cosa cambia" items={p.changes.change} tone="text-sky-700" testid="dup-preview-change" />
        <List icon={CheckCircle2} title="Cosa resta" items={p.changes.keep} tone="text-emerald-700" testid="dup-preview-keep" />
        <List icon={Ban} title="Non viene copiato" items={p.changes.excluded} tone="text-amber-700" testid="dup-preview-excluded" />
      </div>
      {p.warnings?.length > 0 && (
        <div className="flex gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900" data-testid="dup-preview-warnings">
          <AlertTriangle size={16} className="mt-0.5 shrink-0" />
          <div className="space-y-1">{p.warnings.map((w) => <p key={w}>{w}</p>)}</div>
        </div>
      )}
      {p.mode !== "new_sector" && <Replacements rows={rows} setRows={setRows} custom={custom} setCustom={setCustom} ai={ai} />}
      {p.mode === "same_sector" && (
        <div data-testid="dup-preview-texts">
          <p className="text-sm font-semibold text-slate-900">Esempi dei {p.texts.count} testi che l'AI adatterà</p>
          <div className="mt-2 flex flex-wrap gap-1.5">{p.texts.sample.map((t) => <span key={t} className="max-w-[260px] truncate rounded-full bg-slate-100 px-2.5 py-1 text-xs text-slate-700" title={t}>{t}</span>)}</div>
        </div>
      )}
      {p.mode === "new_sector" && (
        <div data-testid="dup-preview-structure">
          <p className="text-sm font-semibold text-slate-900">Struttura dell'originale usata come riferimento</p>
          <div className="mt-2 flex flex-wrap gap-1.5">{p.source.pages.map((pg) => <span key={pg.name} className="rounded-full border px-2.5 py-1 text-xs text-slate-700">{pg.name} · {pg.sections} sezioni</span>)}</div>
        </div>
      )}
      {p.mode !== "new_sector" && p.images.items.length > 0 && (
        <div data-testid="dup-preview-images">
          <p className="text-sm font-semibold text-slate-900">Immagini ({p.images.total})</p>
          <div className="mt-2 grid grid-cols-4 sm:grid-cols-6 gap-2">
            {p.images.items.slice(0, 18).map((im) => (
              <figure key={im.url} className="overflow-hidden rounded-lg border bg-slate-50">
                <img src={assetUrl(im.url)} alt="" loading="lazy" className={`aspect-square w-full ${im.origin === "logo" ? "object-contain p-1.5" : "object-cover"}`} />
                <figcaption className="px-1.5 py-1 text-[9px] leading-tight text-slate-600">{ACTION[im.action]}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      )}
      <CostSummary estimate={p.estimate} confirmed={confirmed} setConfirmed={setConfirmed} />
    </div>
  );
}
